import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const defaultConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="home" fixedWidth />,
    permissions: ['admin', 'person'],
    navLink: '/dashboard',
  },
];

const userConfig = [
  ...defaultConfig,
  {
    id: 'proposals',
    title: 'Proposals',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="clipboard-list" fixedWidth />,
    permissions: ['admin', 'person'],
    navLink: '/proposals',
  },
];

const managerConfig = [...userConfig];

const navigationConfig = (role) => {
  switch (role) {
    case 'Manager':
      return managerConfig;
    case 'User':
      return userConfig;
    default:
      return defaultConfig;
  }
};

export default navigationConfig;
